import { render, staticRenderFns } from "./team-detail-modal.vue?vue&type=template&id=ba72548e&scoped=true"
import script from "./team-detail-modal.vue?vue&type=script&lang=js"
export * from "./team-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./team-detail-modal.vue?vue&type=style&index=0&id=ba72548e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba72548e",
  null
  
)

export default component.exports